import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 600px;
  margin: 0 15px;
  padding: 15px;
  background-color: rgba(93, 165, 237, 0.1);
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Heading = styled.h2`
  font-size: 35px;
  font-weight: 600;
  font-family: font-semibold;
  color: rgba(93, 165, 237, 1);
  margin-bottom: 50px;
`;

export const InputWrapperRow = styled.div`
  width: 100%;
  background-color: #fff;
  overflow: hidden;
  border-radius: 6px;
  margin-bottom: 10px;

  input {
    display: block;
    width: 100%;
    padding: 10px 15px;
    border: none;
    outline: none;
    background: none;
    font-weight: 500;
    font-size: 16px;
    font-family: font-medium;
    color: #363636;

    &::placeholder {
      font-weight: 500;
      font-size: 16px;
      font-family: font-medium;
      color: #a0a0a0;
    }

    &:-ms-input-placeholder {
      font-weight: 500;
      font-size: 16px;
      font-family: font-medium;
      color: #a0a0a0;
    }

    &::-ms-input-placeholder {
      font-weight: 500;
      font-size: 16px;
      font-family: font-medium;
      color: #a0a0a0;
    }
  }
`;

export const Error = styled.p`
  font-weight: 600;
  font-family: font-semibold;
  font-size: 16px;
  text-align: center;
  color: #ff2233;
  margin-top: 20px;
`;

export const LoginButton = styled.div`
  width: 100%;
  padding: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 16px;
  font-family: font-medium;
  color: #ffffff;
  transition: 0.3s;
  background-color: rgba(93, 165, 237, 1);
  margin-top: 25px;
  border-radius: 6px;

  &:hover {
    background-color: #3f87cf;
  }
`;
